import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { IUserRolesResponse } from '../../../../../src/app/static-data/models/user-roles.model';
import {
  fromStaticDataUserRolesSelector,
  fromStaticDataBusinessNamesSelector,
  fromStaticDataProductNamesSelector
} from '../../../static-data/selectors';
import {
  fromStaticDataUserRolesActions,
  fromStaticDataBusinessNamesActions,
  fromStaticDataProductNamesAction
} from '../../../static-data/actions';
import { IBusinessNamesResponse } from '../../../../../src/app/static-data/models/business-names.model';
import { IProductsResponse } from '../../../../../src/app/static-data/models/products.model';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnChanges {
  subscription: Subscription = new Subscription();
  userRoles$: Observable<IUserRolesResponse[]>;
  businessNames$: Observable<IBusinessNamesResponse[]>;
  productNames$: Observable<IProductsResponse[]>;

  firstName: string;
  lastName: string;
  mobileNumber: string;
  emailAddress: string;
  identityNumber: string;

  //#region USER ROLES
  searchUserRolesText: string;
  newUserRolesResults = [];
  //#endregion

  //#region BUSINESS NAMES
  searchBusinessNamesText: string;
  newBusinessNameResults = [];
  //#endregion

  //#region PRODUCT NAMES
  searchProductNamesText: string;
  newProductNamesResults = [];
  //#endregion

  @Output() search = new EventEmitter<{
    firstName: string;
    lastName: string;
    mobileNumber: string;
    emailAddress: string;
    identityNumber: string;
    userRole: string;
    businessName: string;
    product: string;
  }>();
  constructor(private store: Store) {
    this.store.dispatch(fromStaticDataUserRolesActions.loadUserRoles());
    this.store.dispatch(fromStaticDataBusinessNamesActions.loadBusinessNames());
    // !!! IMPORTANT NOTICE !!!
    /*
        This used to call and get all products, but now has changed due to the Product Setting screen
        taking this endpoint and adding pagination.
        Static Data does not contain an endpoint that retrieves all products.
        It is all categorized ... which we can't have in a search autocomplete field.
        I'm adding this note here so we can discuss the next step from here.
    */
  }

  ngOnInit(): void {
    this.userRoles$ = this.store.select(fromStaticDataUserRolesSelector.getStaticDataUserRolesResponse);
    this.businessNames$ = this.store.select(fromStaticDataBusinessNamesSelector.getStaticDataBusinessNamesResponse);
    this.productNames$ = this.store.select(fromStaticDataProductNamesSelector.getStaticDataProductNamesResponse);
  }

  ngOnChanges(): void {
    this.subscription.unsubscribe();
  }

  searchUserRoles(val) {
    this.subscription.add(
      this.userRoles$.subscribe(roles => {
        this.newUserRolesResults = roles.filter(value => value.description.startsWith(val.query));
      })
    );
  }

  searchBusinessNames(val) {
    this.subscription.add(
      this.businessNames$.subscribe(names => {
        this.newBusinessNameResults = names.filter(value => value.description.startsWith(val.query));
      })
    );
  }

  searchProductNames(val) {
    this.subscription.add(
      this.productNames$.subscribe(products => {
        this.newProductNamesResults = products.filter(value => value.description.startsWith(val.query));
      })
    );
  }

  searchBtn() {
    this.search.emit({
      businessName: this.searchBusinessNamesText === undefined ? ' ' : this.searchBusinessNamesText,
      product: this.searchProductNamesText === undefined ? ' ' : this.searchProductNamesText,
      userRole: this.searchUserRolesText === undefined ? ' ' : this.searchUserRolesText,
      emailAddress: this.emailAddress === undefined ? ' ' : this.emailAddress,
      firstName: this.firstName === undefined ? ' ' : this.firstName,
      lastName: this.lastName === undefined ? ' ' : this.lastName,
      identityNumber: this.identityNumber === undefined ? ' ' : this.identityNumber,
      mobileNumber: this.mobileNumber === undefined ? ' ' : this.mobileNumber
    });
  }
}
